<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="dedication" role="doc-dedication">
<p class="SP"> </p>
<p class="Dedication-ded"><span aria-label="v" id="pg_v" role="doc-pagebreak">FOR JEAN,</span></p>
<p class="Dedication-ded">WHO KNEW WHAT THIS BOOK COULD BE BEFORE I DID.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2899d220